var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRaiseHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_261_2436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 4.0625C10 3.6481 10.1646 3.25067 10.4576 2.95765C10.7507 2.66462 11.1481 2.5 11.5625 2.5C11.9769 2.5 12.3743 2.66462 12.6674 2.95765C12.9604 3.25067 13.125 3.6481 13.125 4.0625V8.75",
    stroke: "#F25920",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.875 5.3125V2.8125C6.875 2.3981 7.03962 2.00067 7.33265 1.70765C7.62567 1.41462 8.0231 1.25 8.4375 1.25C8.8519 1.25 9.24933 1.41462 9.54235 1.70765C9.83538 2.00067 10 2.3981 10 2.8125V8.125",
    stroke: "#F25920",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 13.4375C10 12.6087 10.3292 11.8138 10.9153 11.2278C11.5013 10.6417 12.2962 10.3125 13.125 10.3125V8.75C13.125 8.3356 13.2896 7.93817 13.5826 7.64515C13.8757 7.35212 14.2731 7.1875 14.6875 7.1875C15.1019 7.1875 15.4993 7.35212 15.7924 7.64515C16.0854 7.93817 16.25 8.3356 16.25 8.75V11.875C16.25 13.5326 15.5915 15.1223 14.4194 16.2944C13.2473 17.4665 11.6576 18.125 10 18.125C8.3424 18.125 6.75269 17.4665 5.58058 16.2944C4.40848 15.1223 3.75 13.5326 3.75 11.875V5.3125C3.75 4.8981 3.91462 4.50067 4.20765 4.20765C4.50067 3.91462 4.8981 3.75 5.3125 3.75C5.7269 3.75 6.12433 3.91462 6.41735 4.20765C6.71038 4.50067 6.875 4.8981 6.875 5.3125V8.75",
    stroke: "#F25920",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_261_2436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaiseHand);
export default __webpack_public_path__ + "static/media/raise_hand.ea7b0ea39502d53242f6e1bb12eb194c.svg";
export { ForwardRef as ReactComponent };